const tokenKey = 'clientAccessToken'

export function save(token, user) {
  if (user) {
    window.localStorage.setItem('ngStorage-user', JSON.stringify({ 
      id: user?.id, 
      fullName: user?.fullName
    }))
  }
  localStorage.setItem(tokenKey, token)
  return token
}

export function get() {
  const token = localStorage.getItem(tokenKey)
  return token || null
}

export function clear() {
  localStorage.removeItem(tokenKey)
  window.localStorage.removeItem('ngStorage-user')
}

const credentials = {
  save,
  get,
  clear,
}

export default credentials
